import { render } from "./CreateZonePage.vue?vue&type=template&id=0890082a&ts=true"
import script from "./CreateZonePage.vue?vue&type=script&lang=ts"
export * from "./CreateZonePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Zones/CreateZonePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0890082a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0890082a', __exports__)) {
    api.reload('0890082a', __exports__)
  }
  
  module.hot.accept("./CreateZonePage.vue?vue&type=template&id=0890082a&ts=true", () => {
    api.rerender('0890082a', render)
  })

}


export default __exports__